<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-1">
      <h4 v-if="invoiceItems && invoiceItems.length && invoiceItems.length != 0">
        {{$t('invoices')}}
      </h4>
      <div v-else></div>

      <div v-if="$route.name == 'edit-agreements' || viewMode">
        <b-button
          v-if="checkButtonPermission(['chief_manager', 'admin']) &&
          GET_ONE_CONTRACT &&
          GET_ONE_CONTRACT.status &&
          GET_ONE_CONTRACT.status.unique_name != 'close_contract'"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="h-100 d-flex align-items-center"
          @click="openAddInvoiceModal()"
        >
          <feather-icon
            icon="PlusIcon"
            size="16"
            class="mr-50"
          />
          {{$t('add_invoice')}}
        </b-button>
      </div>

    </div>
    <app-collapse class="w-100" type="border">
      <app-collapse-item :title="$t('invoice') +  ' #' + (index1 + 1)" v-for="(item1, index1) in invoiceItems" :key="index1">
        <div v-if="item1.status" class="d-flex flex-wrap justify-content-end align-items-center">
          <template v-for="(item, index) in item1.status.change_to">
            <b-button
              v-if="checkButtonPermission(['chief_manager', 'admin'])"
              :key="index"
              size="sm"
              class="ml-50 mb-50"
              :variant="item.color"
              @click="onChangeStatus(item1, item)"
            >
              {{ item.name }}
            </b-button>
          </template>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            v-if="checkButtonPermission(['chief_manager', 'admin'])"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            class="d-flex align-items-center ml-50"
            variant="success"
            @click="showModalAddFiles(item1.id)"
          >
            <feather-icon
              icon="EyeIcon"
              size="18"
              class="mr-50"
            />
            {{$t('watch_files')}}
          </b-button>
          
          <b-button
            v-if="checkButtonPermission(['chief_manager', 'admin']) && 
            GET_ONE_CONTRACT &&
            GET_ONE_CONTRACT.status &&
            GET_ONE_CONTRACT.status.unique_name != 'close_contract'"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            class="d-flex align-items-center ml-50"
            variant="warning"
            @click="openEditInvoiceModal(item1.id)"
          >
            <feather-icon
              icon="EditIcon"
              size="18"
              class="mr-50"
            />
            {{$t('edit')}}
          </b-button>
        </div>
        <b-table
          :fields="fields"
          :items="item1.items"
          responsive
          :tbody-tr-class="['tableRowClass']"
          class="mt-2 table-bordered border"
          show-empty
          :empty-text="$t('empty_text')"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>
          
          <template #cell(product)="props">
            <div v-if="props.item && props.item.good && props.item.good.product && props.item.good.product.title">
              {{props.item.good.product.title}}
            </div>
            <div v-else>
              {{props.item.instrument.type.title}}
            </div>
          </template>
          
          <template #cell(good)="props">
            <div v-if="props.item.good">
              {{props.item.good.value}}
            </div>
            <div v-else>
              {{props.item.instrument.title}}
            </div>
          </template>
        
          <template #cell(count)="props">
            {{ $_formatPriceMixin(props.item.quantity) }}
          </template>

        </b-table>

        
      </app-collapse-item>
    </app-collapse>

    <addFilesModal2 :type="type"/>

  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { BInputGroup, BFormGroup, BFormInput, BTable, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import areYouSure from '@/mixins/areYouSure'

import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

import addFilesModal2 from '../modals/addFilesModal2.vue'
import priceFormatMixin from '@/mixins/priceFormatMixin';
import check from '@/mixins/check'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BInputGroup,
    BFormGroup,
    BFormInput,
  
    BTable,
    BButton,

    AppCollapse,
    AppCollapseItem,
    
    addFilesModal2,
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure, priceFormatMixin, check],
  data() {
    return {
      fields: [
        {
          label: 'table.product_type',
          key: 'product',
        },
        {
          label: 'reference.name',
          key: 'good',
        },
        {
          label: 'amount',
          key: 'count',
        },
        // {
        //   label: 'actions',
        //   key: 'actions',
        // },
      ],
      type: 'add'
    }
  },
  async mounted(){

  },
  computed: {
    ...mapState('agrements', ['viewMode']),
    ...mapGetters('agrements', ['GET_ONE_CONTRACT']),

    invoiceItems: {
      get: function () {
        return this.$store.state.agrements.invoiceItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INVOICE_ITEMS', newValue)
      }
    },
    invoice_id: {
      get: function () {
        return this.$store.state.agrements.invoice_id;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INVOICE_ID', newValue)
      }
    },
    addContractInvoiceType: {
      get: function () {
        return this.$store.state.agrements.addContractInvoiceType;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_CONTRACT_INVOICE_TYPE', newValue)
      }
    },
    addNewContractInvoice: {
      get: function () {
        return this.$store.state.agrements.addNewContractInvoice;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_NEW_CONTRACT_INVOICE', newValue)
      }
    },

  },
  watch: {

    invoiceItems:{
      deep: true,
      handler(newValue){
        if(newValue){
          newValue.forEach((elem) => {
            elem.items = elem.goods.concat(elem.instruments)
          })
        }
      }
    },

  },
  methods: {


    ...mapActions('agrements', [
      'UPDATE_PATCH_CONTRACT_INVOICE',
      'FETCH_ONE_CONTRACTS'
    ]),


    // ========================= SHOW_MODALS END =========================
    openAddInvoiceModal() {
      this.addContractInvoiceType = false
      this.addNewContractInvoice = true
      this.$bvModal.show('addContractInvoiceModal')
      this.$route.query.invoice = true
    },
    openEditInvoiceModal(id) {
      this.invoice_id = id
      this.addContractInvoiceType = true
      this.addNewContractInvoice = false
      this.$bvModal.show('addContractInvoiceModal')
    },
    showModalAddFiles(id){
      this.invoice_id = id
      this.type = 'show'
      this.$bvModal.show('addFilesModal2')
    },
    // ========================= SHOW_MODALS END =========================





    async refresh(){
      await this.FETCH_ONE_CONTRACTS(this.$route.params.id).then(() => {
        const { invoice } = this.GET_ONE_CONTRACT
        this.invoiceItems = invoice
      })
    },





    deleteApp(data) {
      this.$_showAreYouSureModal().then(val => {
        
        // this.materialAndInstrumentApplications.forEach((item, index) => {
        //   if(item.goods){
        //     item.goods.forEach((elem, index2) => {
        //       if(elem.good.id == data.item.good.id){
        //         this.materialAndInstrumentApplications.splice(index, 1);
        //         this.$store.commit('agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS', this.materialAndInstrumentApplications)
        //       }
        //     })
        //   }
        // })


        // this.materialItems.forEach((elem, index) => {
        //   if(elem.id == data.item.id){
        //     this.materialItems.splice(index, 1);
        //     this.$store.commit('agrements/SET_MATERIAL_ITEMS', this.materialItems)
        //   }
        // })

            
      })
    },




    // ========================= OTHERS START =========================
    onChangeStatus(props, item) {
      const status = {
        accepted_invoice: this.$t('save2'),
      }
      this.$bvModal
        .msgBoxConfirm(
          this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
          {
            title: this.$i18n.t('attention'),
            size: 'sm',
            okVariant: item.color,
            okTitle: this.$t('yes'),
            cancelTitle: this.$t('no'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then(async value => {
          if (!value) return
          this.UPDATE_PATCH_CONTRACT_INVOICE({
            data: {
              status_unique: item.unique_name,
              id: props.id,
            },
            id: props.id,
          }).then( async () => {
            await this.refresh()
          })
        })
    },
    // ========================= OTHERS END =========================



  },
}
</script>

<style lang="scss">
.dark-layout {
  #materials-table {
    border: 1px solid #3b4052;

    .tableRowClass {
      &:nth-child(2n) {
        background: rgba($color: #3b4052, $alpha: 0.7);
      }
    }
  }
}

#materials-table {
  border: 1px solid #f3f2f7;

  th {
    text-align: center;
  }

  .tableRowClass {
    &:nth-child(2n) {
      background: rgba($color: #f3f2f7, $alpha: 0.7);
    }

    td {
      padding: 10px 15px;
      text-align: center;
    }
  }
}
</style>
